import React from 'react';
import { Layout } from 'antd';
import { LayoutProps } from 'antd/lib/layout';

export type LayoutContentProps = LayoutProps;

const ProLayoutContent: React.FC<LayoutContentProps> = React.forwardRef<
  any,
  LayoutContentProps
>((props, ref) => {
  const { children, ...resProps } = props;

  return (
    <Layout.Content ref={ref} {...resProps}>
      {children}
    </Layout.Content>
  );
});

export default ProLayoutContent;
